<!doctype html>
<html lang="en" xmlns="http://www.w3.org/1999/html">
<head>

  <!-- Basic Page Needs
  ================================================== -->
  <title>ระบบค้นหาและแนะนำรหัสประเภทธุรกิจ - กรมพัฒนาธุรกิจการค้า</title>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">
  <base href="/searchResult">

</head>
<body class="gray">
  <div id="wrapper">
    <app-header-mainsearch-result></app-header-mainsearch-result>
  </div>

  <div class="clearfix"></div>
  <!-- Header Container / End -->

  <!-- Page Content
================================================== -->
<!-- Container -->
<div class="container">

	<div class="row">
		<div class="col-xl-12">

			<section id="not-found" class="center margin-top-50 margin-bottom-25">
				<h2>404 <i class="icon-line-awesome-question-circle"></i></h2>
				<p>We're sorry, but the page you were looking for doesn't exist</p>
			</section>

		</div>
	</div>

</div>
<!-- Container / End -->

<!-- Spacer -->
<div class="margin-top-70"></div>

<!-- Footer
================================================== -->
<div id="footer">

	<!-- Footer Copyrights -->
	<div class="footer-bottom-section">
		<div class="container">
			<div class="row">
				<div class="col-xl-12">
					จัดทำโดย กรมพัฒนาธุรกิจการค้า กระทรวงพาณิชย์ (สนามบินน้ำ) 563 ถ.นนทบุรี ต.บางกระสอ อ.เมือง จ.นนทบุรี 11000
				</div>
				<div class="col-xl-12">
					© 2020 <strong>Department of Business Development</strong>. All Rights Reserved.
				</div>
			</div>
		</div>
	</div>
	<!-- Footer Copyrights / End -->

</div>
<!-- Footer / End -->

</body>
